/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { OasDocument } from '../../openapi/models/OasDocument';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20ResponseDefinition } from '../../openapi/v2/models/Oas20ResponseDefinition';
import { RenameResponseDefinitionCommand } from './RenameResponseDefinitionCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends RenameResponseDefinitionCommand
 * @class
 */
export class RenameResponseDefinitionCommand_20 extends RenameResponseDefinitionCommand {
    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super(oldName, newName);
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.RenameResponseDefinitionCommand#_nameToReference(java.lang.String)
     * @param {string} name
     * @return {string}
     */
    _nameToReference(name : string) : string {
        return "#/responses/" + name;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.RenameResponseDefinitionCommand#_renameResponseDefinition(io.apicurio.datamodels.openapi.models.OasDocument, java.lang.String, java.lang.String)
     * @param {OasDocument} document
     * @param {string} fromName
     * @param {string} toName
     * @return {boolean}
     */
    _renameResponseDefinition(document : OasDocument, fromName : string, toName : string) : boolean {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.responses)) {
            return false;
        }
        if(ModelUtils.isDefined(doc20.responses.getResponse(toName))) {
            return false;
        }
        let responseDef : Oas20ResponseDefinition = doc20.responses.removeResponse(fromName);
        responseDef.rename(toName);
        doc20.responses.addResponse(toName, responseDef);
        return true;
    }
}
RenameResponseDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.RenameResponseDefinitionCommand_20";
RenameResponseDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




